import api from '../API';
import { Account, AccountFilters } from '../types';

export default {
  async find(id: number): Promise<Account> {
    const response = await api.get(`accounts/${id}`);
    return response.data;
  },
  async findAll(filters?: AccountFilters): Promise<Account[]> {
    const response = await api.get(
      'accounts',
      { params: filters },
    );
    return response.data;
  },
};
